/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Status_Past_DueInputs */

const fr_membership_status_past_due = /** @type {(inputs: Membership_Status_Past_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paiement en retard`)
};

/**

* @param {Membership_Status_Past_DueInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_status_past_due = /** @type {((inputs?: Membership_Status_Past_DueInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Status_Past_DueInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_status_past_due(inputs)
});